import React, { Component } from 'react';

import MainLayout from './components/MainLayoutComponent';
import './App.css';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import SignupVerificationComponent from "./components/SignupVerificationComponent";
import PasswordResetComponent from "./components/PasswordResetComponent";

class App extends Component {

  render(props) {
    return(
        <BrowserRouter>
                    <Switch>
                        <Route path="/verify/:uid/token/:token" component={SignupVerificationComponent}/>
                        <Route path="/passwordReset/:uid/token/:token" component={PasswordResetComponent}/>
                        <Route path="/" component={MainLayout}/>
                        <Redirect to="/" />
                    </Switch>
        </BrowserRouter>
            );
  }
}

export default App;

